import { authHeader, history } from "../_helpers";
import config from "../config";
import axios from "axios";
export const wantedService = {
  createWantedType,
  getAllWantedType,
  getWantedType,
  updateWantedType,
  getWantedTypeViewsById,
  getWanted,
  createMobile,
  createVehicle,
  createLicenseNumber,
};
//const baseUrl = 'http://localhost:8080/api';
//const baseUrl = 'https://www.criminalmis.in/api';
//const baseUrl = 'https://www.criminalmis.in/api';

 const baseUrl = config.apiGateway.baseUrl;
// const baseUrl = "https://www.criminalmis.in/api";

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
  history.push("login");
}

function handleResponse(response) {
  if (response.status === 401) {
    // auto logout if 401 response returned from api
    logout();
    // location.reload(true);
  }

  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

function createWantedType(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/createwantedtype`, requestOptions).then(
    handleResponse
  );
}

function createLicenseNumber(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/createlicensenumber`, requestOptions).then(
    handleResponse
  );
}

function createVehicle(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/createvehicle`, requestOptions).then(
    handleResponse
  );
}

function createMobile(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/createmobile`, requestOptions).then(
    handleResponse
  );
}

function getWantedType(itemType, role, cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getWantedType/${role}/${itemType}/${cityId}`,
    requestOptions
  ).then(handleResponse);
}
function getAllWantedType(itemType, userid) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getWantedType/${itemType}/${userid}`,
    requestOptions
  ).then(handleResponse);
}

function updateWantedType(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(
    `${baseUrl}/criminal/updateWantedType/${id}`,
    requestOptions
  ).then(handleResponse);
}

function getWantedTypeViewsById(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getwantedtypebyid/${id}`,
    requestOptions
  ).then(handleResponse);
}

function getWanted() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/professional/wantedType`, requestOptions).then(
    handleResponse
  );
}
